import { render } from "./FormManager.vue?vue&type=template&id=27f426b0"
import script from "./FormManager.vue?vue&type=script&lang=js"
export * from "./FormManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__